<template>
  <v-container fluid>
    <el-procuration-step :step="step" />
    <v-card outlined class="mb-4 bg-none">
      <component
        :is="stepComponents[activestep].component"
        :readonly-form="stepComponents[activestep].readonly"
        class="tabComponent"
        @gotoStep="gotoStep"
      ></component>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedDataRoute from '@/mixins/unsavedDataRoute'

import ProcurationStep1 from './ProcurationStep1'
import ProcurationStep2 from './ProcurationStep2'
import ProcurationStep3 from './ProcurationStep3'
import ProcurationStep4 from './ProcurationStep4'
import ProcurationStep5 from './ProcurationStep5'

export default {
  name: 'ProcurationSteps',

  mixins: [userRole, unsavedDataRoute],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      classifiers: [],
    }
  },
  computed: {
    modeReadonly() {
      return false
    },
    step() {
      return this.$route.params.step.toString() || '1'
    },
    getRouteName() {
      return this.$route.name
    },
    stepComponents() {
      return [
        {
          value: 1,
          title: 'Prokūros duomenys',
          component: ProcurationStep1,
          readonly: false,
        },
        {
          value: 2,
          title: 'Prokūros asmenys',
          component: ProcurationStep2,
          readonly: false,
        },
        {
          value: 3,
          title: 'Kontaktiniai duomenys',
          component: ProcurationStep3,
          readonly: false,
        },
        {
          value: 4,
          title: 'Peržiūra',
          component: ProcurationStep4,
          readonly: false,
        },
        {
          value: 5,
          title: 'Apmokėjimas',
          component: ProcurationStep5,
          readonly: false,
        },
      ]
    },
    activestep() {
      const index = this.stepComponents.findIndex((item) => {
        return item.value.toString() === this.step
      })
      return index > 0 ? index : 0
    },
  },
  created() {
    //
  },
  methods: {
    gotoStep(step) {
      this.$router.push({
        name: this.getRouteName,
        params: {
          step: step.step,
          id: step.id,
          parentId: step.parentId,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
